var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"5WKlRw5s9KA4YFQVrlauS"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'
import { APP_ENV, SENTRY_DSN } from '@/configs'
import { SENTRY_IGNORE_ERRORS, sentryBeforeSend } from '@/lib/sentry'

Sentry.init({
  dsn: SENTRY_DSN,
  replaysSessionSampleRate: 0.1,
  autoSessionTracking: false,
  replaysOnErrorSampleRate: 1.0,
  // Adjust this value in production, or use tracesSampler for greater control
  environment: APP_ENV || 'development',
  enabled: process.env.NODE_ENV === 'production',
  tracesSampleRate: 1.0,
  ignoreErrors: SENTRY_IGNORE_ERRORS,
  beforeSend: sentryBeforeSend,
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
})
